import { render } from "./UiMessage.vue?vue&type=template&id=2bcadfa2&scoped=true&lang=pug"
import script from "./UiMessage.vue?vue&type=script&lang=js"
export * from "./UiMessage.vue?vue&type=script&lang=js"

import "./UiMessage.vue?vue&type=style&index=0&id=2bcadfa2&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcadfa2"]])

export default __exports__